import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminDestinations() {
  return (
    <AdminCrud
      title="Destinations"
      resource="destinations"
      defaultItem={{
        name: "",
        slug: "",
        region: "",
        description: "",
        image_url: "",
        highlights: [],
        order: 1,
      }}
      fields={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug (URL)" },
        { key: "region", label: "Region" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "image_url", label: "Image", type: "image" },
        { key: "highlights", label: "Highlights (one per line)", type: "list" },
        { key: "order", label: "Order", type: "number" },
      ]}
    />
  );
}